import Formulario from './Formulario';

export default Formulario;